module.exports = {
      id: "facebook-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "img/icons.209f7259.svg#facebook-usage",
      toString: function () {
        return this.url;
      }
    }